const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressCompletedInverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-completed-inverse",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconR-progress-completed-inverse1",
    serifid: "iconR-progress-completed-inverse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c0,7.727 -6.273,14 -14,14c-7.727,0 -14,-6.273 -14,-14c0,-7.727 6.273,-14 14,-14Zm0,2.181c6.523,-0 11.819,5.296 11.819,11.819c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-6.523 5.296,-11.819 11.819,-11.819Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.851,21.431c-0.262,0.151 -0.45,0.404 -0.519,0.699c-0.069,0.294 -0.013,0.604 0.155,0.856c2.61,3.744 6.9,6.014 11.513,6.014c7.727,-0 14,-6.273 14,-14c0,-7.338 -5.646,-13.358 -12.831,-13.952c-0.299,-0.018 -0.593,0.088 -0.812,0.294c-0.218,0.206 -0.357,0.494 -0.357,0.794c0,0.005 0,0.002 0,0.004c0.001,0.581 0.453,1.063 1.033,1.1c6.045,0.509 10.786,5.581 10.786,11.76c0,6.523 -5.296,11.819 -11.819,11.819c-3.881,0 -7.492,-1.903 -9.69,-5.051c-0.317,-0.473 -0.963,-0.623 -1.457,-0.338c-0.008,0.005 0.003,-0.001 -0.002,0.001Zm17.506,-9.48c0,-1.836 -1.315,-3.315 -2.922,-3.315l-6.87,0c-1.607,0 -2.922,1.479 -2.922,3.315c-0,-0 -0,6.098 -0,6.098c-0,1.834 1.315,3.315 2.922,3.315c0,-0 6.87,-0 6.87,-0c1.607,-0 2.922,-1.481 2.922,-3.315l0,-6.098Zm-3.816,-1.042l0.894,-0c0.501,-0 0.894,0.471 0.894,1.042l0,6.098c0,0.573 -0.393,1.042 -0.894,1.042c-0,0 -6.87,0 -6.87,0c-0.501,0 -0.894,-0.469 -0.894,-1.042l-0,-6.098c-0,-0.571 0.393,-1.042 0.894,-1.042l0.894,-0c0,-0 0,2.348 0,2.348c0,1.114 0.8,2.008 1.778,2.008l1.526,-0c0.978,-0 1.778,-0.894 1.778,-2.008l-0,-2.348Zm-3.054,-0l1.026,-0l-0,2.084l-1.026,-0l0,-2.084Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressCompletedInverse);
export default __webpack_public_path__ + "static/media/iconR-progress-completed-inverse.1045f279a68698c76a595e9e8987d624.svg";
export { ForwardRef as ReactComponent };